import '../stylesheets/main.css';

/*eslint-disable */
$(document).ready(function() {
  /**
   * Finds all inputs with required attribute and prepends elToAdd
   */
  function markRequiredFields (elToAdd) {
    $('input').each((idx, el) => {
      let jEl = $(el)
      if (jEl.prop('required') || jEl.hasClass('required')) {
        jEl.siblings('label').prepend(elToAdd + ' ')
      }
    })
  }

  const requiredFieldsMarker = '<span class="text-danger">*</span>';

  markRequiredFields(requiredFieldsMarker);

  if ($('#fullpage').length > 0) {
    $('#fullpage').fullpage({
      anchors: ['first-page', 'second-page', 'third-page', 'fourth-page', 'last-page'],
      menu: '#my-menu'
    },(function() {
      $('#fullpage').css('visibility', 'visible');
    })());

    $('.read-more').click(function(){
      $.fn.fullpage.moveSectionDown();
    });
  }

  function toggleNavigation() {
    $('body').toggleClass('mobile-open');
  }

  $('.burger-menu').click(function(){
    toggleNavigation();
  });

  $(document).click(function(e){
    if ($('.mobile-open').length > 0) {
      if ($(e.target).closest('.mobile-menu').length === 0 && $(e.target).closest('.burger-menu').length === 0) {
        $('body').removeClass('mobile-open');
      }
    }
  });

  if ($('.has-sub-wrapper').length > 0) {
    $('.has-sub-wrapper').change(function(){
      var parent = $(this).parent('.checkbox');
      var subWrapper = $(parent).find('.checked-sub-wrapper');
      if (this.checked) {
        $(subWrapper).find('.required').prop('required', true);
        $(subWrapper).css('display', 'block');
      } else {
        $(subWrapper).find('.required').prop('required', false);
        $(subWrapper).css('display', 'none');
      }
    });
  }

  function needsString(data) {
    var str = '';
    if (data.wash) {
      if (data.wash_type === 'periodic') {
        str += 'Periodisk rengjøring ';
        if (data.frequency === 'weekly') {
          str += '(hver uke)';
        } else if (data.frequency === 'every-two-weeks') {
          str += '(annenhver uke)';
        } else if (data.frequency === 'just-this-once') {
          str += '(bare denne gangen)';
        }
      } else if (data.wash_type === 'move') {
        str += 'Flyttevask';
      }
    }
    if (data.help) {
      if (str.length) str += '; ';
      str += 'Enkle oppdrag i hjemmet';
    }
    if (data.craftsman_services) {
      if (str.length) str += '; ';
      str += 'Håndverkstjenester';
    }
    return str;
  }

  /**
   * Contact form
   */
  
  $('.contact-form-submit').attr('disabled', 'disabled');

  $('#check-consent').on('click', (e) => {
    if (e.target.checked) {
      $('.contact-form-submit').prop('disabled', false);
      $('#check-consent + label').removeAttr('style');
    } else {
      $('.contact-form-submit').attr('disabled', 'disabled');
    }
  })

  $(document).on('submit', '.contact-form-form', function(ev) {
    ev.preventDefault();
    var data = {};
    // var fields = [
    //   'first_name',
    //   'last_name',
    //   'email',
    //   'phone',
    //   'address',
    //   'post_number',
    //   'city',
    //   'wash',
    //   'weekly-wash',
    //   'moving-wash',
    //   'how-often-weekly',
    //   'every-other-week',
    //   'just-this-once',
    //   'other',
    //   'help',
    //   'craftsman-services',
    // ]
    var mappings = {
      first_name: 'firstName',
      last_name: 'lastName',
    };

    if (! $('#check-consent').prop('checked')) {
      $('#check-consent + label').css('color', 'red')

      return;
    }

    $('.contact-form-form').serializeArray().forEach(function(field) {
      data[(mappings[field.name] || field.name)] = field.value;
    });
    // console.log('data', data);
    data['needs'] = needsString(data);
    // console.log('needs', data.needs);
    $('.contact-form-submit').val('Sender...').attr('disabled', true);
    $.ajax({
      url: 'https://api.velghvitt.no/api/v1/vaskerhvitt-register-form',
      // url: 'https://pub.levelup.no/client_endpoints/vaskerhvitt_contact_form',
      // url: 'http://localhost:6447/client_endpoints/vaskerhvitt_contact_form',
      data: JSON.stringify(data),
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      crossOrigin: true,
      jsonp: false,
      processData: false,
      // xhrFields: { withCredentials: true },
      accept: 'application/json',
    }).done(function(res) {
      // console.log('res', res);
      $('.contact-form-submit').val('Takk, beskjeden ble sendt!');
    }).fail(function(xhr, textStatus, error) {
      console.error(textStatus, error);
    });
  });
});
/*eslint-enable */



// WEBPACK FOOTER //
// ./client/endpoints/main.js